import { render } from "./CrudVeiculoTrator.vue?vue&type=template&id=2397a0a4"
import script from "./CrudVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CrudVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script